import { render, staticRenderFns } from "./StaffDetails.vue?vue&type=template&id=45f37bc0&"
import script from "./StaffDetails.vue?vue&type=script&lang=js&"
export * from "./StaffDetails.vue?vue&type=script&lang=js&"
import style0 from "./StaffDetails.vue?vue&type=style&index=0&id=45f37bc0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports